import { LoadableLazy } from '@confluence/loadable';

export const LazyJiraLinkAutomationDiscoveryDialog = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-JiraLinkAutomationDiscoveryDialog" */ '../src/JiraLinkAutomationDiscoveryDialog.tsx'
			)
		).JiraLinkAutomationDiscoveryDialog,
});
